package com.mps.asc_app.ui.theme

import androidx.compose.ui.graphics.Color

// Vereinsfarben wie auf der neuen Vereinsseite (asc-design.css, 22.10.2026): Blau + Gold.
val AscNavy = Color(0xFF123467)
val AscNavy2 = Color(0xFF1D4C8C)
val AscNavyInk = Color(0xFF0B2246)
val AscGold = Color(0xFFC79A2E)
val AscGoldLight = Color(0xFFE2BC5C)
val AscBackground = Color(0xFFF3F5F8)
val AscInk = Color(0xFF14202F)
val AscMuted = Color(0xFF5A6577)
val AscLine = Color(0xFFDDE3EB)

val Primary = AscNavy
val OnPrimary = Color(0xFFFFFFFF)
val PrimaryContainer = Color(0xFFE6EDF7)
val OnPrimaryContainer = AscNavyInk

// Gold nur als Flaeche mit dunkler Schrift (Gold auf Weiss ist als Textfarbe zu kontrastarm).
val Secondary = AscGold
val OnSecondary = AscNavyInk
val SecondaryContainer = Color(0xFFF6EBD0)
val OnSecondaryContainer = Color(0xFF6B4E0F)

val Tertiary = AscNavy2
val OnTertiary = Color(0xFFFFFFFF)
val TertiaryContainer = Color(0xFFDCE7F6)
val OnTertiaryContainer = AscNavyInk

val Background = AscBackground
val OnBackground = AscInk
val Surface = Color(0xFFFFFFFF)
val OnSurface = AscInk
val SurfaceVariant = Color(0xFFE9ECF0)
val OnSurfaceVariant = AscMuted

val Outline = Color(0xFFB8C3D3)
val OutlineVariant = AscLine

val Error = Color(0xFFBA1A1A)
val OnError = Color(0xFFFFFFFF)
val ErrorContainer = Color(0xFFFFDAD6)
val OnErrorContainer = Color(0xFF410002)

/** Farben der Slot-Kacheln im Kalender (Legende: frei, belegt, deine Buchung, gesperrt). */
object SlotColors {
    val FreeContainer = Color(0xFFFFFFFF)
    val FreeBorder = Outline
    val FreeContent = AscNavy
    val BookedContainer = PrimaryContainer
    val BookedContent = AscNavy
    val ProvisionalContainer = SecondaryContainer
    val ProvisionalContent = OnSecondaryContainer
    val BlockedContainer = SurfaceVariant
    val BlockedContent = AscMuted
}
